class Socket{
    private ws:WebSocket|null = null;
    private host:string|null = null;
    private token:string|null = null;
    private isConnected:boolean = false;
    private message: ((e: any) => any) | null = null

    constructor(host:string, token:string){
        this.host = host; this.token = token;
        this.connect();
    }

    connect(){
        const wsUrl = `${this.host}?token=${this.token}`
        this.ws = new WebSocket(wsUrl);
        this.ws.onopen = ()=>{
            this.isConnected = true
            console.log('Socket Connected');
            
        }
        this.ws.onclose = ()=>{
            this.isConnected = false;
            setTimeout(()=>{
                this.connect()
            },1000)
        }
        this.ws.onmessage = (e)=>{
            const data = JSON.parse(e.data);
            if (typeof this.message === 'function') {
                try {
                    this.message(data);
                } catch (err) {
                    console.error('Ws message handler error:', err);
                }
            }
        }
    }

    onMessage(handler:(e:any)=>any){
        try {
            this.message = handler
        } catch (error) {
            console.error(`Ws error:`, error);
        }
    }

    send(msg:string){
        if(this.ws && this.isConnected){
            this.ws.send(msg)
        }
    }

    close(): void {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
            this.isConnected = false;
            this.message = null
        }
    }
}

export default Socket